import type {
  PathologyOrderCreateRequest,
  PathologyOrderGetAllParams,
  PathologyOrderGetAllResponse,
  PathologyOrderGetResponseWithId,
} from '@quromedical/models';
import type { PathologyTestSearchResult } from '@quromedical/pathology';
import { trpcClient } from 'trpc';

export enum PathologyEndpoint {
  Ampath = 'ampath',
}

interface PathologyTestSearchParams {
  query?: string;
  specialOrder?: boolean;
  commonOnly?: boolean;
  limit?: number;
}

export class PathologyApi {
  getPathologyOrders = async (
    params: PathologyOrderGetAllParams,
  ): Promise<PathologyOrderGetAllResponse> =>
    trpcClient.pathologyRequest.getAll.query(params);

  searchAmpathTests = async (
    params: PathologyTestSearchParams,
  ): Promise<PathologyTestSearchResult[]> => {
    return await trpcClient.pathologyRequest.searchTests.query(params);
  };

  public async createAmpathRequest(
    req: PathologyOrderCreateRequest,
  ): Promise<PathologyOrderGetResponseWithId> {
    return await trpcClient.patient.createPathologyRequest.mutate(req);
  }
}
